// The current Terms version: the "Last updated" date on /terms, and what a
// new account records when it accepts them. Change it whenever the Terms change.
const TERMS_VERSION = '2026-10-30';

function termsVersionLabel(version = TERMS_VERSION) {
  return new Date(`${version}T00:00:00Z`).toLocaleDateString('en-US', {month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC'});
}

module.exports = {TERMS_VERSION, termsVersionLabel};
